export const UPDATE_PAPER_WIDTH = 'UPDATE_PAPER_WIDTH';
export const UPDATE_PAPER_HEIGHT = 'UPDATE_PAPER_HEIGHT';
export const UPDATE_PAPER_LAYOUT = 'UPDATE_PAPER_LAYOUT';
export const UPDATE_BORDER = 'UPDATE_BORDER';
export const UPDATE_PAPER_WIDTH_PX = 'UPDATE_PAPER_WIDTH_PX';
export const UPDATE_PAPER_HEIGHT_PX = 'UPDATE_PAPER_HEIGHT_PX';
export const UPDATE_GRID = 'UPDATE_GRID';
export const UPDATE_GRID_SIZE = 'UPDATE_GRID_SIZE';
export const UPDATE_GRID_COLOR = 'UPDATE_GRID_COLOR';
export const UPDATE_GRID_SECOND = 'UPDATE_GRID_SECOND';
export const UPDATE_GRID_SIZE_SECOND = 'UPDATE_GRID_SIZE_SECOND';
export const UPDATE_GRID_COLOR_SECOND = 'UPDATE_GRID_COLOR_SECOND';
export const SET_SHOW_GRID_LABELS = 'SET_SHOW_GRID_LABELS';
export const UPDATE_FIT_IMAGE = 'UPDATE_FIT_IMAGE';
export const UPDATE_GRAYSCALE = 'UPDATE_GRAYSCALE';
export const TOGGLE_SETTINGS = 'TOGGLE_SETTINGS';
export const SET_IMAGE = 'SET_IMAGE';
export const SET_ALLOW_DRAG = 'SET_ALLOW_DRAG';
export const SET_PICKING_COLOR = 'SET_PICKING_COLOR';
export const SET_PICKED_COLOR = 'SET_PICKED_COLOR';
export const SET_IMAGE_SCALE = 'SET_IMAGE_SCALE';
export const SET_IMAGE_DOWNLOADING = 'SET_IMAGE_DOWNLOADING';
export const SET_IMAGE_DOWNLOADED = 'SET_IMAGE_DOWNLOADED';
export const ADD_REFERENCE_COLOR = 'ADD_REFERENCE_COLOR';
export const SET_REFERENCE_COLORS = 'SET_REFERENCE_COLORS';
export const ADD_COLOR_GROUP = 'ADD_COLOR_GROUP';
export const SET_SHOW_COLOR_PALETTE = 'SET_SHOW_COLOR_PALETTE';
export const SET_SHOW_SAVE_MODAL = 'SET_SHOW_SAVE_MODAL';
export const SET_SHOW_LOAD_MODAL = 'SET_SHOW_LOAD_MODAL';
